import React from "react";
import { Chip } from "@mui/material";
import { getBadgeStyles } from "../../../../components/ui/badgeColors";
import { getColorEstadoCompra, getEtiquetaEstadoCompra } from "../../helpers/estadosCompras";

/**
 * Badge del estado de un pedido de compra (colores en COLOR_ESTADO_COMPRA)
 */
const EstadoCompraBadge = ({ estado }) => (
    <Chip
        label={getEtiquetaEstadoCompra(estado)}
        size="small"
        sx={getBadgeStyles(getColorEstadoCompra(estado))}
    />
);

export default EstadoCompraBadge;
